import * as React from 'react';

import './DummyProgress.scss';

export interface IDummyProgressProps {
  className?: string;
}

export const DummyProgress: React.FC<React.PropsWithChildren<IDummyProgressProps>> = ({ children, className = '' }) => {
  return (
    <div className={`no-progress ${className}`}>
      <p>{children}</p>
      <div>
        <svg viewBox="0 0 100 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="no-progress-bars">
              <rect x="1" y="5" width="4" height="16"></rect>
              <rect x="7.5" y="15" width="4" height="6"></rect>
              <rect x="14" y="3" width="4" height="18"></rect>
              <rect x="20.5" y="12" width="4" height="9"></rect>
              <rect x="27" y="0" width="4" height="21"></rect>
              <rect x="33.5" y="19" width="4" height="2"></rect>
              <rect x="40" y="2" width="4" height="19"></rect>
              <rect x="46.5" y="1" width="4" height="20"></rect>
              <rect x="53" y="16" width="4" height="5"></rect>
              <rect x="59.5" y="6" width="4" height="15"></rect>
              <rect x="66" y="13" width="4" height="8"></rect>
              <rect x="72.5" y="0" width="4" height="21"></rect>
              <rect x="79" y="2" width="4" height="19"></rect>
              <rect x="85.5" y="5" width="4" height="16"></rect>
              <rect x="92" y="19" width="4" height="2"></rect>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default DummyProgress;
